import type { PmVersion } from '@/types';
import { fmtNum } from '../bq-insights/bqMath';

/** First day the rollups hold (the backend's PM_FLOOR_DATE). */
export const PM_MIN_DATE = '2026-10-01';

/** "All versions", then the versions by player-days; keeps the chosen one visible if it isn't listed. */
export function versionOptions(versions: PmVersion[], value: string) {
  const options = [
    { value: 'all', label: 'All versions' },
    ...versions.map((v) => ({
      value: v.version,
      label: `${v.version} (${fmtNum(v.dau)} player-days, 30 d)`,
    })),
  ];
  if (!options.some((o) => o.value === value)) options.push({ value, label: value });
  return options;
}
